<template>
  <!-- 赠品兑换单 -->
  <div class="giftExchange">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="handleExport"
          >导出</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <div class="searchBar">
      <label class="label">配送类型：</label>
      <el-select
        placeholder="配送类型"
        style="width: 100px; margin-right: 5px"
        v-model="searchForm.distributionType"
        clearable
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="随货配送" value="随货配送"></el-option>
        <el-option label="结束后十日内" value="结束后十日内"></el-option>
      </el-select>
      <label class="label">验收状态：</label>
      <el-select
        placeholder="验收状态"
        style="width: 100px; margin-right: 5px"
        v-model="searchForm.acceptancePhase"
        clearable
      >
        <el-option label="全部" value="99"></el-option>
        <el-option label="未兑付" value="0"></el-option>
        <el-option label="未验收" value="1"></el-option>
        <el-option label="已验收" value="2"></el-option>
      </el-select>
      <label class="label">是否延迟：</label>
      <el-select
        placeholder="是否延迟"
        style="width: 100px; margin-right: 5px"
        v-model="searchForm.delay"
        clearable
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="正常" value="N"></el-option>
        <el-option label="延迟" value="Y"></el-option>
      </el-select>
      <el-date-picker
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        clearable
        v-model="searchForm.startDate"
        style="width: 200px; margin-right: 5px"
        placeholder="开始日期"
      >
      </el-date-picker>
      <el-date-picker
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        clearable
        v-model="searchForm.endDate"
        style="width: 200px; margin-right: 5px"
        placeholder="结束日期"
      >
      </el-date-picker>
      <el-date-picker
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        clearable
        v-model="searchForm.cachedDateMin"
        style="width: 200px; margin-right: 5px"
        placeholder="兑付开始日期"
      >
      </el-date-picker>
      <el-date-picker
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        clearable
        v-model="searchForm.cachedDateMax"
        style="width: 200px; margin-right: 5px"
        placeholder="兑付结束日期"
      >
      </el-date-picker>
      <el-input
        style="width: 200px; margin-right: 5px"
        clearable
        placeholder="输入订单号"
        v-model="searchForm.name"
      ></el-input>
      <el-button type="primary" icon="el-icon-search" @click="seach"
        >搜索</el-button
      >
    </div>

    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 200px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="OrderNo"
        show-overflow-tooltip
        label="订单号"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="RecordDate"
        align="center"
        show-overflow-tooltip
        label="日期"
        width="150"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="UserName"
        label="用户名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column
        prop="BusinessName"
        label="单位"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="shouhdz"
        label="收货地址"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column> -->
      <el-table-column
        prop="salezMan"
        label="业务员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="BillingSupervisor"
        label="开票员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="GiftName"
        label="赠品"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Quantity"
        label="数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="CashingDate"
        label="兑付时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="StatusName"
        label="订单状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="primary">{{ scope.row.StatusName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.Status == '0'">未兑付</el-tag>
          <el-tag type="warning" v-else-if="scope.row.Status == '1'"
            >未签收</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.Status == '2'"
            >已签收</el-tag
          >
          <el-tag type="info" v-else>未定义</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Delay"
        label="延迟收货"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.Delay == "Y" ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="SupplementRecord"
        label="补录记录"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Notes"
        label="备注"
        align="center"
        width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="150" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="handleBtn1">补录</el-button> -->
          <el-button
            v-if="scope.row.Status == '0' && scope.row.OrderStatus != '0'"
            type="text"
            @click="handleBtn2(scope.row)"
            >兑付</el-button
          >
          <el-button type="text" @click="handleBtn3(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "giftExchange",
  data() {
    return {
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        distributionType: "", //配送类型
        acceptancePhase: "99", // 验收类型
        delay: "", // 是否延时
        name: "", //订单号
        startDate: "", //日期范围
        endDate: "", //日期范围
        cachedDateMin: "", //兑付开始日期
        cachedDateMax: "", // 兑付结束日期
      },
    };
  },
  mounted() {
    this.searchForm.startDate = this.$theMonthFirstDay();
    this.searchForm.endDate = this.$formatDate(new Date().getTime());
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    seach() {
      this.getTableData(1);
    },

    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GiftCashingRecord",
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        strWhere: this.searchForm.name,
        delay: this.searchForm.delay,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        cashingType: this.searchForm.distributionType,
        cachedDateMin: this.searchForm.cachedDateMin,
        cachedDateMax: this.searchForm.cachedDateMax,
      };

      let proc = "Proc_Admin_Order"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "rechargeorder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 查看详细信息
    lookDetail(row) {
      let parms = null;
      let parmser = {
        lsh: row.Lsh,
        source: row.source,
        Amount: row.Amount,
      };
      parms = JSON.stringify(parmser);
      this.$router.push({
        path: "RefundRequestDetail",
        query: {
          row: parms,
        },
      });
      parms = null;
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**补录 */
    handleBtn1(row) {
      let data = {
        type: "GiftCashingSupplement",
        list: row.Id,
      };

      let proc = "Proc_Admin_Order"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "rechargeorder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          let type = "success";
          if (res.flag == 0) {
            this.getTableData(this.currPage);
          } else {
            type = "error";
          }
          this.$message({
            message: res.message,
            type,
          });
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**兑付 */
    handleBtn2(row) {
      this.$confirm("确定兑付吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            type: "GiftCashing",
            list: row.Id,
            status: 1,
          };

          let proc = "Proc_Admin_Order"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              let type = "success";
              if (res.flag == 0) {
                this.getTableData(this.currPage);
              } else {
                type = "error";
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**备注 */
    handleBtn3(row) {
      this.$prompt("请输入备注内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let data = {
            type: "GiftCashingNotes",
            list: row.Id,
            notes: value,
          };

          let proc = "Proc_Admin_Order"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              let type = "success";
              if (res.flag == 0) {
                this.getTableData(this.currPage);
              } else {
                type = "error";
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**点击导出 */
    handleExport() {
      let data = {
        type: "GiftCashingRecord",
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        strWhere: this.searchForm.name,
        delay: this.searchForm.delay,
        PageIndex: 1,
        PageSize: 99999,
        cashingType: this.searchForm.distributionType,
        cachedDateMin: this.searchForm.cachedDateMin,
        cachedDateMax: this.searchForm.cachedDateMax,
      };

      let proc = "Proc_Admin_Order"; //存储过程名
      window.location.href =
        this.baseUrl +
        "/Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=赠品兑付";
    },
  },
};
</script>

<style scoped>
.giftExchange {
  width: 100%;
  height: 100%;
}

.searchBar {
  height: 100px;
  /* display: flex; */
  /* justify-content: flex-end; */
  box-sizing: border-box;
  padding: 0 10px;
  text-align: right;
  line-height: 45px;
}
</style>
